var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('small',[_vm._v("© 2021. Made with ❤️ by Aldi Tegar Prakoso")])])}]

export { render, staticRenderFns }